var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"footer",staticClass:"footer"},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"info"},[_vm._v("Copyright 2025, MelodyStep Limited. All Rights Reserved.")]),_c('div',{staticClass:"info"})])
}]

export { render, staticRenderFns }